/**
 * Matomo tracking events (spec §4). The Matomo snippet itself is rendered
 * server-side (views/frontend/main.php) and consent-gated; this module only
 * queues events into the `_paq` queue, which the snippet consumes on load.
 * Without the snippet (tracking disabled or excluded page) the queue simply
 * accumulates harmlessly.
 */

// §4.2 Outbound Mastercard clicks — label-based via `data-matomo-outbound`,
// bound by data attribute, never by label text (the internal anchor on
// /mastercard shares the "Zum Teilnahmeformular" label). Fires on external
// https hrefs only; URL-level detail stays in the outlink reports via the
// snippet's untouched auto outlink tracking (`enableLinkTracking`).
// document.addEventListener(
// 	"click",
// 	(event) => {
// 		if (!(event.target instanceof Element)) return;

// 		const link = event.target.closest("a[data-matomo-outbound]");

// 		if (!link) return;

// 		const href = link.getAttribute("href");

// 		if (!href || !/^https:/i.test(href)) return;

// 		const label = link.getAttribute("data-matomo-outbound");

// 		if (!label) return;

// 		const _paq = (window._paq = window._paq || []);
// 		_paq.push(["trackEvent", "Outbound", "Klick", label]);
// 	},
// 	true
// );

// §4.3 Conversion — the success view (bestaetigung.php) renders only on the
// server-side isSubmitted() branch (visa/home.php, formular.php), so the
// attribute is the server's decision; this module relays it into the queue.
// No inline script: the CSP script-src allows no unsafe-inline.
const conversion = document.querySelector("[data-matomo-event]");

if (conversion) {
	try {
		const [category, action, name] = JSON.parse(conversion.dataset.matomoEvent);
		const _paq = (window._paq = window._paq || []);
		_paq.push(["trackEvent", category, action, name]);
	} catch {
		// a malformed attribute must not break the listeners bound below
	}
}

// §4.4 Bank selection — one event, name = the chosen bank's display name.
// Fires on real selection (the select's `change`), never on keystrokes in
// the search box. Event-only insight, not a conversion.
document.querySelectorAll('select[id^="select-genossenschaftsbank"]').forEach((select) => {
	select.addEventListener("change", (event) => {
		const option = event.target.selectedOptions ? event.target.selectedOptions[0] : null;
		const bank = option ? option.textContent.trim() : "";

		if (!bank) return;

		const _paq = (window._paq = window._paq || []);
		_paq.push(["trackEvent", "Formular", "Bank-Auswahl", bank]);
	});
});




/**
 * Matomo click events
 */

const MATOMO_CATEGORY = "ExternerLink";
const MATOMO_ACTION = "Klick";

const CLICK_EVENT_NAMES = {
	"startseite-mastercard-karteneinsatz": "Priceless",
	"startseite-visa-karteneinsatz": "VR-Entertain",
	"mastercard-karteneinsatz": "Priceless",
	"mastercard-kartenabsatz": "Mastercard",
	"mastercard-kartenabsatz-teaser": "Mastercard",
	"visa-karteneinsatz": "VR-Entertain",
	"visa-optin-karteneinsatz": "VR-Entertain",
	"visa-optin2-karteneinsatz": "VR-Entertain",
};

document.addEventListener(
	"click",
	(event) => {
		if (!(event.target instanceof Element)) return;

		const selector = Object.keys(CLICK_EVENT_NAMES)
			.map((id) => `#${id}`)
			.join(",");

		const target = event.target.closest(selector);

		if (!target) return;

		const name = CLICK_EVENT_NAMES[target.id];

		if (!name) return;

		const _paq = (window._paq = window._paq || []);
		_paq.push(["trackEvent", MATOMO_CATEGORY, MATOMO_ACTION, name]);
	},
	true
);
